import { isBookable } from "@@/shared/acquire/is-bookable";
import type { Sku } from "@@/shared/products/sku";
import type { Translatable } from "@@/shared/translations/translation";

/**
 * Sku item description based on unit and amount of items
 * _(will be used if sku hasn't got another description already)_
 * @param {Sku} sku
 * @returns {Translatable}
 */
const getSkuDescription = (sku: Sku): Translatable => {
    if (isBookable(sku.acquire) || sku.acquire._type === "VOUCHER") {
        return sku.meta.description;
    }

    return (
        sku.meta.description ||
        (sku.acquire.amount.unit.name &&
            `à ${sku.acquire.amount.value} ${sku.acquire.amount.unit.name}`)
    );
};

export { getSkuDescription };
